export const translations: Record<string, Record<string, string>> = {
  es: {

    // NAV — new keys
    'nav.howwework': 'Cómo trabajamos',
    'nav.founder': 'Nosotros',
    'nav.service.whatsapp': 'Automatizar WhatsApp con IA',
    'nav.service.business': 'Automatizaciones empresariales',
    'nav.service.data': 'Análisis de Datos y Big Data',
    'nav.service.chatbots': 'Chatbots y Asistentes Virtuales',
    'nav.service.logistics': 'Optimización de Procesos y Logística',
    'nav.service.marketing': 'Optimización de Marketing Digital',

    // FOOTER
    'footer.tagline': 'Convertimos procesos en sistemas inteligentes. IA aplicada a negocios reales.',
    'footer.col.company': 'Empresa',
    'footer.col.services': 'Servicios',
    'footer.col.products': 'Productos',
    'footer.rights': 'Todos los derechos reservados.',
    'footer.made': 'Hecho con IA + ingeniería naval',

    // TESTIMONIALS
    'testimonials.badge': 'Lo que dicen nuestros clientes',
    'testimonials.title': 'Resultados reales, empresas reales',
    'testimonials.subtitle': 'No trabajamos con promesas. Trabajamos con entregables.',
    'testimonials.t1.name': 'Pamela Torales',
    'testimonials.t1.role': 'BM Paddle',
    'testimonials.t1.quote': 'BookerClub transformó por completo la gestión de nuestro club. Lo que antes nos llevaba horas de planillas ahora lo manejamos en minutos. El sistema de reservas y notificaciones cambió la experiencia de nuestros socios.',
    'testimonials.t2.name': 'Marcelo Furtado',
    'testimonials.t2.role': 'MJF Furtado Advisors',
    'testimonials.t2.quote': 'La página funciona perfecto. Cargo y actualizo las propiedades yo mismo en minutos, sin depender de nadie, y las descripciones en español e inglés me sirven para los compradores del exterior. Quedó exactamente como la necesitaba.',
    'testimonials.t3.name': 'Leo Risolini',
    'testimonials.t3.role': 'Palo Alto Polo Club',
    'testimonials.t3.quote': 'Simplificando me ahorró horas de papelerío con mi empleada doméstica. Todo claro, todo legal, y con MercadoPago integrado. Exactamente lo que necesitaba sin complicaciones.',

    // NAV
    'nav.services': 'Servicios',
    'nav.contact': 'Contacto',
    'nav.projects': 'Proyectos',


    // HERO — new
    'hero.tag': 'Agencia de IA · Buenos Aires · LATAM',
    'hero.title1': 'Convertimos tus procesos',
    'hero.title2': 'en sistemas inteligentes',
    'hero.subtitle': 'Automatización con IA, SaaS a medida y soluciones digitales que generan resultados reales — no promesas genéricas.',
    'hero.cta.primary': 'Hablemos de tu proyecto',
    'hero.cta.secondary': 'Ver proyectos',
    'hero.stat1.number': '10',
    'hero.stat1.label': 'Proyectos en producción',
    'hero.stat2.number': '30+',
    'hero.stat2.label': 'Años en ingeniería de sistemas',
    'hero.stat3.number': '6',
    'hero.stat3.label': 'Industrias atendidas',
    'hero.industries': 'Industrias: Seguridad · Clubes deportivos · Náutica · Agro · Legal · Polo',
    // HERO (legacy)
    'hero.description': 'Desarrollamos soluciones de IA personalizadas que potencian la eficiencia y el crecimiento de tu negocio. Descubre el poder de la automatización inteligente con AiLosofy.',

    // SERVICES SECTION
    'services.mainTitle': '💡 Potencia tu Empresa con IA',
    'services.discover': 'Descubre el poder de la Inteligencia Artificial para optimizar procesos, mejorar la experiencia de tus clientes y llevar tu empresa al siguiente nivel.',
    'services.whatWeCanDo': '📈 ¿Qué podemos hacer por ti?',
    'services.automation.title': 'Automatización Inteligente',
    'services.automation.description': 'Simplifica tareas repetitivas y libera tiempo para lo que realmente importa.',
    'services.predictive.title': 'Análisis Predictivo',
    'services.predictive.description': 'Toma decisiones basadas en datos con precisión y rapidez.',
    'services.chatbots.title': 'Asistentes Virtuales Personalizados',
    'services.chatbots.description': 'Mejora la atención al cliente con chatbots inteligentes que entienden y responden a tus usuarios en tiempo real.',
    'services.future.title': '🌐 Experimenta el Futuro Hoy',
    'services.future.description': 'Da el paso hacia la transformación digital con tecnología de vanguardia.',

    // WHATSAPP
    'whatsapp.title': 'WhatsApp con Inteligencia Artificial',
    'whatsapp.subtitle': 'Transforma la Atención al Cliente con WhatsApp Automatizado y IA',
    'whatsapp.quickResponses': 'Respuestas Rápidas y Eficientes',
    'whatsapp.quickResponsesDesc': 'Respuestas instantáneas, incluso fuera del horario laboral',
    'whatsapp.availability': 'Disponibilidad 24/7',
    'whatsapp.availabilityDesc': 'Tu negocio siempre disponible para tus clientes',
    'whatsapp.costs': 'Reducción de Costos Operativos',
    'whatsapp.costsDesc': 'Optimiza recursos y mejora la eficiencia',

    // BUSINESS
    'business.title': 'Automatización de Procesos Empresariales con IA',
    'business.subtitle': 'Impulsa la Eficiencia de Tu Negocio con Inteligencia Artificial',
    'business.description': 'En un entorno empresarial cada vez más competitivo, optimizar los procesos internos es clave para mejorar la eficiencia y reducir costos. Aprovechamos el poder de la Inteligencia Artificial para transformar la manera en que operas.',

    // DATA
    'data.title': 'Análisis de Datos y Big Data',
    'data.subtitle': 'Transformamos datos en decisiones estratégicas para impulsar el crecimiento de tu negocio',
    'data.description': 'Utilizamos tecnologías avanzadas de análisis de datos y Big Data para descubrir patrones, tendencias y oportunidades que impulsan la innovación y el crecimiento empresarial.',

    // CHATBOTS
    'chatbots.title': 'Chatbots y Asistentes Virtuales Inteligentes',
    'chatbots.subtitle': 'Transformando la Atención al Cliente con Inteligencia Artificial',
    'chatbots.description': 'En la era digital, la rapidez y la personalización en la atención al cliente son esenciales. Ofrecemos soluciones avanzadas diseñadas para mejorar la interacción con los usuarios y optimizar el servicio al cliente de manera eficiente.',

    // LOGISTICS
    'logistics.title': 'Optimización de Procesos y Logística',
    'logistics.subtitle': 'Transforma tu cadena de suministro con inteligencia artificial',
    'logistics.description': 'En un mundo empresarial cada vez más exigente, la eficiencia en los procesos y la logística es crucial para mantener la competitividad. Utilizamos IA para transformar la forma en que gestionas tus operaciones.',

    // MARKETING
    'marketing.title': 'Optimización de Marketing Digital con Inteligencia Artificial',
    'marketing.subtitle': 'En un mundo digital en constante evolución, las empresas enfrentan el desafío de destacarse en un mar de competidores.',
    'marketing.description': 'La Optimización de Marketing Digital a través de la Inteligencia Artificial se presenta como una solución integral para maximizar el impacto de tus campañas y mejorar la experiencia del cliente.',




    // SERVICES DETAIL SECTION
    'svc.badge': 'Nuestros Servicios',
    'svc.title': '💡 Soluciones de IA para cada necesidad',
    'svc.subtitle': 'Servicios diseñados para empresas que quieren resultados reales, no proyectos piloto eternos.',
    'svc.benefitsTitle': 'Beneficios concretos',
    'svc.cta': 'Quiero este servicio',
    // WhatsApp
    'svc.whatsapp.title': 'WhatsApp con Inteligencia Artificial',
    'svc.whatsapp.subtitle': 'Automatizá tu canal de WhatsApp y atendé 24/7 sin contratar más personal',
    'svc.whatsapp.desc': 'Transformamos tu WhatsApp en un agente de ventas y atención al cliente que nunca duerme. Captura leads, procesa pedidos, responde consultas y escala sin límites — todo integrado con tus sistemas.',
    'svc.whatsapp.b1': '⚡ Respuestas instantáneas las 24hs, incluso fuera del horario laboral',
    'svc.whatsapp.b2': '📈 Más leads capturados sin aumentar el equipo de ventas',
    'svc.whatsapp.b3': '💰 Reducción de costos operativos de atención al cliente',
    'svc.whatsapp.b4': '🔗 Integración con tus sistemas CRM, e-commerce y logística',
    'svc.whatsapp.types': 'Tipos de IA para WhatsApp',
    'svc.whatsapp.t1.label': 'IA para Generación de Leads',
    'svc.whatsapp.t1.desc': 'Captura datos de potenciales clientes en conversaciones automáticas y los integra a tu CRM.',
    'svc.whatsapp.t2.label': 'IA de Procesamiento de Pedidos',
    'svc.whatsapp.t2.desc': 'Permite hacer pedidos, elegir productos, pagar y recibir confirmaciones sin intervención humana.',
    'svc.whatsapp.t3.label': 'IA para Soporte Técnico',
    'svc.whatsapp.t3.desc': 'Resuelve problemas técnicos desde configuraciones básicas hasta incidencias complejas.',
    'svc.whatsapp.t4.label': 'IA de Atención al Cliente',
    'svc.whatsapp.t4.desc': 'Gestiona consultas frecuentes y deriva los casos complejos a un agente humano.',
    // Business Automation
    'svc.business.title': 'Automatización de Procesos Empresariales',
    'svc.business.subtitle': 'Eliminá el trabajo manual y liberá a tu equipo para lo que importa',
    'svc.business.desc': 'Identificamos los procesos repetitivos que consumen tiempo y los automatizamos con IA. Desde aprobaciones de documentos hasta reportes automáticos — tu equipo se enfoca en decisiones estratégicas.',
    'svc.business.b1': '⏱️ Reducción drástica del tiempo en tareas manuales y repetitivas',
    'svc.business.b2': '✅ Cero errores humanos en procesos críticos',
    'svc.business.b3': '💸 Menor costo operativo por proceso automatizado',
    'svc.business.b4': '📐 Escalable: el sistema crece con tu empresa sin fricción',
    // Data Analysis
    'svc.data.title': 'Análisis de Datos y Big Data',
    'svc.data.subtitle': 'Convertí tus datos en ventaja competitiva',
    'svc.data.desc': 'Tenés datos pero no sabés qué te están diciendo. Nosotros los transformamos en insights accionables: qué clientes van a comprar, qué procesos están fallando, dónde está la próxima oportunidad.',
    'svc.data.b1': '📊 Decisiones basadas en datos, no en intuición',
    'svc.data.b2': '🔍 Patrones ocultos que tu competencia no ve',
    'svc.data.b3': '⚙️ Optimización de procesos con evidencia real',
    'svc.data.b4': '🏆 Ventaja competitiva sostenible en el tiempo',
    // Chatbots
    'svc.chatbots.title': 'Chatbots y Asistentes Virtuales',
    'svc.chatbots.subtitle': 'Atención personalizada a escala, sin escalar el equipo',
    'svc.chatbots.desc': 'Construimos asistentes virtuales que entienden el contexto, recuerdan conversaciones anteriores y resuelven el 80% de las consultas sin intervención humana. Disponibles en tu web, app o redes sociales.',
    'svc.chatbots.b1': '🕐 Disponibilidad 24/7 sin interrupciones ni días de descanso',
    'svc.chatbots.b2': '💬 Atención personalizada basada en el historial del usuario',
    'svc.chatbots.b3': '⚡ Múltiples conversaciones simultáneas sin degradar la calidad',
    'svc.chatbots.b4': '🎯 Experiencia consistente en todos los canales',
    // Logistics
    'svc.logistics.title': 'Optimización de Procesos y Logística',
    'svc.logistics.subtitle': 'Menos costos, más velocidad, mejor servicio',
    'svc.logistics.desc': 'Aplicamos IA a tu cadena de suministro y operaciones logísticas. Predecimos demanda, optimizamos rutas, reducimos inventario innecesario y mejoramos los tiempos de entrega.',
    'svc.logistics.b1': '💰 Reducción de gastos operativos identificando ineficiencias',
    'svc.logistics.b2': '📡 Visibilidad en tiempo real de productos y procesos',
    'svc.logistics.b3': '🚀 Entregas más rápidas y menor tasa de error',
    'svc.logistics.b4': '🔄 Adaptación automática a cambios de demanda del mercado',
    // Marketing
    'svc.marketing.title': 'Optimización de Marketing Digital',
    'svc.marketing.subtitle': 'Más impacto con el mismo presupuesto',
    'svc.marketing.desc': 'Usamos IA para segmentar mejor, personalizar contenido y optimizar tus campañas en tiempo real. Más conversiones, menor costo por adquisición, mejores clientes.',
    'svc.marketing.b1': '🎯 Segmentación precisa por comportamiento e intereses reales',
    'svc.marketing.b2': '👤 Contenido personalizado para cada segmento de usuario',
    'svc.marketing.b3': '📈 Monitoreo y optimización de campañas en tiempo real',
    'svc.marketing.b4': '📐 Sistema escalable que mejora con cada campaña',

    // HOW WE WORK
    'howwework.badge': 'Nuestro proceso',
    'howwework.title': 'Cómo trabajamos',
    'howwework.subtitle': 'Un proceso claro y probado. Sin sorpresas, sin promesas vacías — solo ejecución.',
    'howwework.step1.title': 'Discovery',
    'howwework.step1.desc': 'Entendemos tu negocio, tus procesos actuales y dónde la IA puede generar el mayor impacto.',
    'howwework.step2.title': 'Propuesta',
    'howwework.step2.desc': 'Diseñamos la solución técnica y el plan de trabajo con tiempos, entregables y costos claros.',
    'howwework.step3.title': 'Build',
    'howwework.step3.desc': 'Construimos con metodología ágil. Iteraciones rápidas, feedback constante, código limpio.',
    'howwework.step4.title': 'Deploy',
    'howwework.step4.desc': 'Lanzamos en producción con testing riguroso. Tu equipo queda capacitado para operar.',
    'howwework.step5.title': 'Evolución',
    'howwework.step5.desc': 'Monitoreamos, mejoramos y escalamos. La solución crece con tu negocio.',
    'howwework.guaranteesTitle': 'Lo que garantizamos en cada proyecto',
    'howwework.g1': '⚡ Primeros resultados en 30 días — no esperamos meses para mostrar valor.',
    'howwework.g2': '🔒 IP 100% tuya — todo el código y los datos son de tu empresa.',
    'howwework.g3': '📦 Entregables concretos — documentación, código fuente y capacitación incluidos.',
    'howwework.g4': '🤝 Comunicación directa — trabajás con el founder, no con una cadena de intermediarios.',
    'howwework.cta': 'Iniciá tu proyecto',

    // FOUNDER SECTION
    'founder.badge': 'El equipo detrás de AiLosofy',
    'founder.title': 'Ingeniería de alto rendimiento aplicada a los negocios',
    'founder.subtitle': 'No somos una agencia genérica de IA. Venimos de construir sistemas que no pueden fallar — en el océano, en regatas, en la industria.',
    'founder.timelineTitle': 'Trayectoria',
    'founder.milestone1': '🎓 Ingeniero Naval con más de 30 años en ingeniería de sistemas complejos — diseñando soluciones donde el margen de error es cero.',
    'founder.milestone2': '🏆 America\'s Cup y Volvo Ocean Race — construcción de embarcaciones y project management en competencias de vela de élite, donde los plazos, la precisión y el trabajo bajo presión son innegociables.',
    'founder.milestone3': '🚢 Co-fundador de BoatShare, primera plataforma de boat-sharing de Argentina — de la idea al exit.',
    'founder.milestone4': '🤖 Fundador de AiLosofy: agencia de IA y estudio de SaaS con 8+ productos lanzados en seguridad, clubes deportivos, náutica, agro, legal y polo.',
    'founder.pillarsTitle': 'Lo que nos hace diferentes',
    'founder.pillar1': '🧠 Pensamiento sistémico aplicado — cada solución de IA está diseñada como un sistema, no como un parche.',
    'founder.pillar2': '⚙️ Builder, no solo consultor — construimos los productos que vendemos y los usamos nosotros mismos.',
    'founder.pillar3': '🌊 Cultura de alto rendimiento — venimos de entornos donde la mediocridad no es una opción.',
    'founder.pillar4': '🌎 LATAM-first con visión global — profundo conocimiento del mercado local con capacidad de escalar internacionalmente.',
    'founder.cta': 'Trabajemos juntos',

    // CONTACT
    'contact.title': 'Lleva tu empresa al Siguiente Nivel',
    'contact.description': 'En AiLosofy, desarrollamos soluciones de automatización personalizadas para cada empresa, asegurando que tu negocio mejore en eficiencia, agilidad y adaptación.',
    'contact.faq': 'Preguntas Frecuentes',
    'contact.contactUs': 'Contáctanos',
    'contact.name': 'Nombre y apellido',
    'contact.email': 'Correo Electrónico',
    'contact.phone': 'Teléfono',
    'contact.message': 'Mensaje',
    'contact.send': 'Enviar Mensaje',
    'contact.heading': 'Contacto',
    'contact.subheading': 'Comienza la automatización de tu empresa con AiLosofy y nuestros servicios de Inteligencia Artificial para mejorar la productividad.',
    'contact.chatbot': 'También puedes usar nuestro chatbot para contactarnos 24/7',
    'contact.founderBook': 'Libro del fundador',
    'contact.bookTitle': 'Cuándo No Hacer Nada',
    'contact.bookAvailable': 'Disponible en Amazon',

    // GET STARTED
    'getstarted.title': 'Llevá tu empresa al Siguiente Nivel',
    'getstarted.description': 'En AiLosofy, desarrollamos soluciones de automatización personalizadas para cada empresa, asegurando que tu negocio mejore en eficiencia, agilidad y adaptación.',
    'getstarted.faq': 'Preguntas Frecuentes',
    'getstarted.optimize': 'Optimizá tu negocio con Inteligencia Artificial',
    'getstarted.question': '¿Querés mejorar la eficiencia de tu empresa y aumentar tus resultados con Inteligencia Artificial? 🚀',
    'getstarted.body1': 'En AiLosofy, diseñamos soluciones de IA personalizadas para optimizar procesos, automatizar tareas y potenciar tu negocio.',
    'getstarted.body2': 'Contanos qué necesitás y descubrí cómo podemos ayudarte. Completá el formulario y te contactaremos con una propuesta adaptada a tu empresa:',
    'getstarted.cta': 'Comenzar ahora',

    // PROJECTS SECTION
    'projects.badge': 'Nuestros Proyectos',
    'projects.title': '🎯 Cada proyecto es un sistema funcionando en producción',
    'projects.description': 'Desde clubes deportivos hasta trazabilidad ganadera con IoT: software propio y a medida para empresas de Argentina y la región.',
    'projects.visitSite': 'Visitar sitio →',
    'projects.ownProduct': 'Producto AiLosofy',
    'projects.client': 'Cliente',
    'projects.ctaQuestion': '¿Querés transformar tu negocio con IA?',
    'projects.ctaButton': 'Hablemos de tu proyecto',

    // PROJECTS — BookerClub
    'projects.booker.subtitle': 'Gestión Integral de Clubes Deportivos',
    'projects.booker.desc': 'SaaS multi-tenant para digitalización total de clubes: clases, escuelitas, torneos, bar, estadísticas y app móvil. Gestión de reservas, pagos y notificaciones push para padel, tenis y más.',

    // PROJECTS — ShiftMaster
    'projects.shiftmaster.subtitle': 'Control Inteligente de Turnos y Personal',
    'projects.shiftmaster.desc': 'Plataforma RRHH para cadenas multi-sucursal: control de turnos, asistencia con GPS anti-spoofing, detección automática de ausencias y sistema de cobertura de guardias vía comunicación directa.',

    // PROJECTS — Simplificando
    'projects.simplificando.subtitle': 'Gestión de Empleados de Casas Particulares',
    'projects.simplificando.desc': 'PWA para monotributistas argentinos que simplifica el registro y gestión de empleados domésticos. Integración con MercadoPago, suscripciones, liquidaciones y cumplimiento legal automatizado.',

    // PROJECTS — Santa Tabla
    'projects.santatabla.subtitle': 'E-commerce Inteligente + Automatización',
    'projects.santatabla.desc': 'Plataforma con IA para optimizar ventas y experiencia de compra. Shop técnico especializado en tablas y equipamiento para deportes acuáticos desde 2013, potenciado con automatización total.',

    // PROJECTS — Dato que Dato
    'projects.datoquedato.subtitle': 'Marketplace de Servicios + Geolocalización',
    'projects.datoquedato.desc': 'Conectamos usuarios con profesionales de oficios urbanos. La IA prioriza a los mejor valorados cerca del usuario por oficio, facilitando encontrar al profesional más recomendado para cada necesidad.',

    // PROJECTS — CasaBlanca
    'projects.casablanca.subtitle': 'Configurador de Mallets + E-commerce',
    'projects.casablanca.desc': 'PWA de pedidos para equipamiento de polo de alta performance en fibra de carbono. Flujo de personalización en 5 pasos con render SVG de mallets en tiempo real, integrado con sistema de reparación.',

    'projects.weatherspot.subtitle': 'Viento y clima para deportes acuáticos',
    'projects.weatherspot.desc': 'PWA white-label de pronóstico de viento para kite, windsurf y vela. Integración con 11 estaciones Windguru vía Cloudflare Worker proxy. Datos en tiempo real de viento, olas y condiciones meteorológicas.',

        // PROJECTS — Ganaval
    'projects.ganaval.subtitle': 'Trazabilidad Ganadera con IoT y LoRaWAN',
    'projects.ganaval.desc': 'Plataforma de rastreo y scoring de ganado bovino con caravanas IoT y antenas LoRaWAN. Permite a bancos verificar el ganado como garantía de crédito en tiempo real. Piloto en General Pico y Trenque Lauquen.',

        // PROJECTS — SecureTrack Pro
    'projects.securetrack.subtitle': 'Fichaje Biométrico para Cooperativas de Seguridad',
    'projects.securetrack.desc': 'Plataforma de control de asistencia con kiosco de fichaje biométrico y geolocalización. Multi-cooperativa con paneles diferenciados por rol y comprobantes conformes al Art. 42 Ley 20.337. En producción con Sinergia (~500 asociados).',

    // PROJECTS — GRIM
    'projects.grim.subtitle': 'PWA de Productividad para The GRIM Circle',
    'projects.grim.desc': 'Sistema de ejecución diaria para miembros de The GRIM Circle: Deep Work con drag & drop, habit tracking, check-in de disciplina, notificaciones GRIM y seguimiento de objetivos semanales.',

    // PROJECTS — MJF
    'projects.mjf.subtitle': 'Argentina\'s Land. Your Legacy.',
    'projects.mjf.desc': 'Sitio web para MJ Furtado Advisors, especialista en tierras agrícolas e inversiones en Argentina. Posicionamiento premium para compradores internacionales que buscan activos rurales de alto valor.',
  },

  en: {

    // NAV — new keys
    'nav.howwework': 'How we work',
    'nav.founder': 'About us',
    'nav.service.whatsapp': 'Automate WhatsApp with AI',
    'nav.service.business': 'Business Automation',
    'nav.service.data': 'Data Analysis and Big Data',
    'nav.service.chatbots': 'Chatbots and Virtual Assistants',
    'nav.service.logistics': 'Process and Logistics Optimization',
    'nav.service.marketing': 'Digital Marketing Optimization',

    // FOOTER
    'footer.tagline': 'We turn processes into intelligent systems. AI applied to real businesses.',
    'footer.col.company': 'Company',
    'footer.col.services': 'Services',
    'footer.col.products': 'Products',
    'footer.rights': 'All rights reserved.',
    'footer.made': 'Built with AI + naval engineering',

    // TESTIMONIALS
    'testimonials.badge': 'What our clients say',
    'testimonials.title': 'Real results, real companies',
    'testimonials.subtitle': "We don\'t work with promises. We work with deliverables.",
    'testimonials.t1.name': 'Pamela Torales',
    'testimonials.t1.role': 'BM Paddle',
    'testimonials.t1.quote': 'BookerClub completely transformed how we manage our club. What used to take hours of spreadsheets we now handle in minutes. The reservation and notification system changed the experience for our members.',
    'testimonials.t2.name': 'Marcelo Furtado',
    'testimonials.t2.role': 'MJF Furtado Advisors',
    'testimonials.t2.quote': 'The site works perfectly. I upload and update listings myself in minutes, without depending on anyone, and the Spanish and English descriptions work well for buyers abroad. It turned out exactly as I needed it.',
    'testimonials.t3.name': 'Leo Risolini',
    'testimonials.t3.role': 'Palo Alto Polo Club',
    'testimonials.t3.quote': 'Simplificando saved me hours of paperwork with my domestic employee. Everything clear, everything legal, with MercadoPago integrated. Exactly what I needed without complications.',

    // NAV
    'nav.services': 'Services',
    'nav.contact': 'Contact',
    'nav.projects': 'Projects',


    // HERO — new
    'hero.tag': 'AI Agency · Buenos Aires · LATAM',
    'hero.title1': 'We turn your processes',
    'hero.title2': 'into intelligent systems',
    'hero.subtitle': 'AI automation, custom SaaS, and digital solutions that generate real results — not generic promises.',
    'hero.cta.primary': "Let's talk about your project",
    'hero.cta.secondary': 'See projects',
    'hero.stat1.number': '10',
    'hero.stat1.label': 'Projects in production',
    'hero.stat2.number': '30+',
    'hero.stat2.label': 'Years in systems engineering',
    'hero.stat3.number': '6',
    'hero.stat3.label': 'Industries served',
    'hero.industries': 'Industries: Security · Sports clubs · Maritime · Agro · Legal · Polo',
    // HERO (legacy)
    'hero.description': 'We develop custom AI solutions that enhance your business efficiency and growth. Discover the power of intelligent automation with AiLosofy.',

    // SERVICES SECTION
    'services.mainTitle': '💡 Power Your Business with AI',
    'services.discover': 'Discover the power of Artificial Intelligence to optimize processes, enhance customer experience, and take your business to the next level.',
    'services.whatWeCanDo': '📈 What can we do for you?',
    'services.automation.title': 'Intelligent Automation',
    'services.automation.description': 'Simplify repetitive tasks and free up time for what really matters.',
    'services.predictive.title': 'Predictive Analytics',
    'services.predictive.description': 'Make data-driven decisions with precision and speed.',
    'services.chatbots.title': 'Custom Virtual Assistants',
    'services.chatbots.description': 'Enhance customer service with intelligent chatbots that understand and respond to your users in real-time.',
    'services.future.title': '🌐 Experience the Future Today',
    'services.future.description': 'Take the step towards digital transformation with cutting-edge technology.',

    // WHATSAPP
    'whatsapp.title': 'WhatsApp with Artificial Intelligence',
    'whatsapp.subtitle': 'Transform Customer Service with Automated WhatsApp and AI',
    'whatsapp.quickResponses': 'Fast and Efficient Responses',
    'whatsapp.quickResponsesDesc': 'Instant responses, even outside business hours',
    'whatsapp.availability': '24/7 Availability',
    'whatsapp.availabilityDesc': 'Your business always available for your customers',
    'whatsapp.costs': 'Reduced Operating Costs',
    'whatsapp.costsDesc': 'Optimize resources and improve efficiency',

    // BUSINESS
    'business.title': 'Business Process Automation with AI',
    'business.subtitle': 'Boost Your Business Efficiency with Artificial Intelligence',
    'business.description': 'In an increasingly competitive business environment, optimizing internal processes is key to improving efficiency and reducing costs. We harness the power of Artificial Intelligence to transform the way you operate.',

    // DATA
    'data.title': 'Data Analysis and Big Data',
    'data.subtitle': 'We transform data into strategic decisions to drive your business growth',
    'data.description': 'We use advanced data analysis and Big Data technologies to uncover patterns, trends, and opportunities that drive business innovation and growth.',

    // CHATBOTS
    'chatbots.title': 'Intelligent Chatbots and Virtual Assistants',
    'chatbots.subtitle': 'Transforming Customer Service with Artificial Intelligence',
    'chatbots.description': 'In the digital era, speed and personalization in customer service are essential. We offer advanced solutions designed to improve user interaction and optimize customer service efficiently.',

    // LOGISTICS
    'logistics.title': 'Process and Logistics Optimization',
    'logistics.subtitle': 'Transform your supply chain with artificial intelligence',
    'logistics.description': 'In an increasingly demanding business world, process and logistics efficiency is crucial to maintain competitiveness. We use AI to transform how you manage your operations.',

    // MARKETING
    'marketing.title': 'Digital Marketing Optimization with AI',
    'marketing.subtitle': 'In an ever-evolving digital world, businesses face the challenge of standing out in a sea of competitors.',
    'marketing.description': 'Digital Marketing Optimization through Artificial Intelligence presents itself as a comprehensive solution to maximize the impact of your campaigns and improve customer experience.',




    // SERVICES DETAIL SECTION
    'svc.badge': 'Our Services',
    'svc.title': '💡 AI Solutions for every need',
    'svc.subtitle': 'Services designed for companies that want real results, not endless pilot projects.',
    'svc.benefitsTitle': 'Concrete benefits',
    'svc.cta': 'I want this service',
    // WhatsApp
    'svc.whatsapp.title': 'WhatsApp with Artificial Intelligence',
    'svc.whatsapp.subtitle': 'Automate your WhatsApp channel and serve customers 24/7 without hiring more staff',
    'svc.whatsapp.desc': 'We transform your WhatsApp into a sales and customer service agent that never sleeps. Captures leads, processes orders, answers queries, and scales without limits — all integrated with your systems.',
    'svc.whatsapp.b1': '⚡ Instant responses 24/7, even outside business hours',
    'svc.whatsapp.b2': '📈 More leads captured without expanding the sales team',
    'svc.whatsapp.b3': '💰 Reduced customer service operating costs',
    'svc.whatsapp.b4': '🔗 Integration with your CRM, e-commerce, and logistics systems',
    'svc.whatsapp.types': 'Types of AI for WhatsApp',
    'svc.whatsapp.t1.label': 'Lead Generation AI',
    'svc.whatsapp.t1.desc': 'Captures potential customer data in automated conversations and integrates it into your CRM.',
    'svc.whatsapp.t2.label': 'Order Processing AI',
    'svc.whatsapp.t2.desc': 'Allows placing orders, choosing products, paying, and receiving confirmations without human intervention.',
    'svc.whatsapp.t3.label': 'Technical Support AI',
    'svc.whatsapp.t3.desc': 'Solves technical problems from basic configurations to complex incidents.',
    'svc.whatsapp.t4.label': 'Customer Service AI',
    'svc.whatsapp.t4.desc': 'Handles frequently asked questions and escalates complex cases to a human agent.',
    // Business Automation
    'svc.business.title': 'Business Process Automation',
    'svc.business.subtitle': 'Eliminate manual work and free your team for what matters',
    'svc.business.desc': 'We identify repetitive processes that consume time and automate them with AI. From document approvals to automatic reports — your team focuses on strategic decisions.',
    'svc.business.b1': '⏱️ Drastic reduction in time spent on manual and repetitive tasks',
    'svc.business.b2': '✅ Zero human errors in critical processes',
    'svc.business.b3': '💸 Lower operating cost per automated process',
    'svc.business.b4': '📐 Scalable: the system grows with your company without friction',
    // Data Analysis
    'svc.data.title': 'Data Analysis and Big Data',
    'svc.data.subtitle': 'Turn your data into competitive advantage',
    'svc.data.desc': 'You have data but don\'t know what it\'s telling you. We transform it into actionable insights: which customers will buy, which processes are failing, where the next opportunity is.',
    'svc.data.b1': '📊 Decisions based on data, not intuition',
    'svc.data.b2': '🔍 Hidden patterns your competition doesn\'t see',
    'svc.data.b3': '⚙️ Process optimization with real evidence',
    'svc.data.b4': '🏆 Sustainable competitive advantage over time',
    // Chatbots
    'svc.chatbots.title': 'Chatbots and Virtual Assistants',
    'svc.chatbots.subtitle': 'Personalized service at scale, without scaling the team',
    'svc.chatbots.desc': 'We build virtual assistants that understand context, remember previous conversations, and resolve 80% of queries without human intervention. Available on your website, app, or social networks.',
    'svc.chatbots.b1': '🕐 24/7 availability without interruptions or days off',
    'svc.chatbots.b2': '💬 Personalized service based on user history',
    'svc.chatbots.b3': '⚡ Multiple simultaneous conversations without degrading quality',
    'svc.chatbots.b4': '🎯 Consistent experience across all channels',
    // Logistics
    'svc.logistics.title': 'Process and Logistics Optimization',
    'svc.logistics.subtitle': 'Less costs, more speed, better service',
    'svc.logistics.desc': 'We apply AI to your supply chain and logistics operations. We predict demand, optimize routes, reduce unnecessary inventory, and improve delivery times.',
    'svc.logistics.b1': '💰 Reduced operating expenses by identifying inefficiencies',
    'svc.logistics.b2': '📡 Real-time visibility of products and processes',
    'svc.logistics.b3': '🚀 Faster deliveries and lower error rate',
    'svc.logistics.b4': '🔄 Automatic adaptation to market demand changes',
    // Marketing
    'svc.marketing.title': 'Digital Marketing Optimization',
    'svc.marketing.subtitle': 'More impact with the same budget',
    'svc.marketing.desc': 'We use AI to better segment, personalize content, and optimize your campaigns in real time. More conversions, lower acquisition cost, better customers.',
    'svc.marketing.b1': '🎯 Precise segmentation by real behavior and interests',
    'svc.marketing.b2': '👤 Personalized content for each user segment',
    'svc.marketing.b3': '📈 Real-time campaign monitoring and optimization',
    'svc.marketing.b4': '📐 Scalable system that improves with every campaign',

    // HOW WE WORK
    'howwework.badge': 'Our process',
    'howwework.title': 'How we work',
    'howwework.subtitle': 'A clear, proven process. No surprises, no empty promises — just execution.',
    'howwework.step1.title': 'Discovery',
    'howwework.step1.desc': 'We understand your business, your current processes, and where AI can generate the greatest impact.',
    'howwework.step2.title': 'Proposal',
    'howwework.step2.desc': 'We design the technical solution and work plan with clear timelines, deliverables, and costs.',
    'howwework.step3.title': 'Build',
    'howwework.step3.desc': 'We build with agile methodology. Fast iterations, constant feedback, clean code.',
    'howwework.step4.title': 'Deploy',
    'howwework.step4.desc': 'We launch to production with rigorous testing. Your team is trained and ready to operate.',
    'howwework.step5.title': 'Evolution',
    'howwework.step5.desc': 'We monitor, improve, and scale. The solution grows with your business.',
    'howwework.guaranteesTitle': 'What we guarantee on every project',
    'howwework.g1': '⚡ First results in 30 days — we don\'t wait months to show value.',
    'howwework.g2': '🔒 100% your IP — all code and data belong to your company.',
    'howwework.g3': '📦 Concrete deliverables — documentation, source code, and training included.',
    'howwework.g4': '🤝 Direct communication — you work with the founder, not a chain of middlemen.',
    'howwework.cta': 'Start your project',

    // FOUNDER SECTION
    'founder.badge': 'The team behind AiLosofy',
    'founder.title': 'High-performance engineering applied to business',
    'founder.subtitle': "We\'re not a generic AI agency. We come from building systems that cannot fail — on the ocean, in regattas, in industry.",
    'founder.timelineTitle': 'Track record',
    'founder.milestone1': '🎓 Naval Engineer with 30+ years in complex systems engineering — designing solutions where the margin for error is zero.',
    'founder.milestone2': "🏆 Competitor in the America\'s Cup and Volvo Ocean Race — environments where strategy, data, and execution under pressure are everything.",
    'founder.milestone3': '🚢 Co-founder of BoatShare, Argentina\'s first boat-sharing platform — from idea to exit.',
    'founder.milestone4': '🤖 Founder of AiLosofy: AI agency and SaaS studio with 8+ products launched across security, sports clubs, maritime, agro, legal, and polo.',
    'founder.pillarsTitle': 'What makes us different',
    'founder.pillar1': '🧠 Systems thinking applied — every AI solution is engineered as a system, not a patch.',
    'founder.pillar2': '⚙️ Builder, not just consultant — we build the products we sell and use them ourselves.',
    'founder.pillar3': '🌊 High-performance culture — we come from environments where mediocrity is not an option.',
    'founder.pillar4': '🌎 LATAM-first with global vision — deep local market knowledge with the capacity to scale internationally.',
    'founder.cta': "Let's work together",

    // CONTACT
    'contact.title': 'Take Your Business to the Next Level',
    'contact.description': 'At AiLosofy, we develop customized automation solutions for each company, ensuring that your business improves in efficiency, agility, and adaptation.',
    'contact.faq': 'Frequently Asked Questions',
    'contact.contactUs': 'Contact Us',
    'contact.name': 'Full Name',
    'contact.email': 'Email',
    'contact.phone': 'Phone',
    'contact.message': 'Message',
    'contact.send': 'Send Message',
    'contact.heading': 'Contact',
    'contact.subheading': 'Start automating your company with AiLosofy and our Artificial Intelligence services to improve productivity.',
    'contact.chatbot': 'You can also use our chatbot to contact us 24/7',
    'contact.founderBook': "Founder's book",
    'contact.bookTitle': 'When Not to Do Anything',
    'contact.bookAvailable': 'Available on Amazon',

    // GET STARTED
    'getstarted.title': 'Take Your Business to the Next Level',
    'getstarted.description': 'At AiLosofy, we develop customized automation solutions for each company, ensuring that your business improves in efficiency, agility, and adaptation.',
    'getstarted.faq': 'Frequently Asked Questions',
    'getstarted.optimize': 'Optimize your business with Artificial Intelligence',
    'getstarted.question': 'Want to improve your business efficiency and boost results with Artificial Intelligence? 🚀',
    'getstarted.body1': 'At AiLosofy, we design custom AI solutions to optimize processes, automate tasks, and power your business.',
    'getstarted.body2': 'Tell us what you need and discover how we can help. Fill out the form and we will contact you with a proposal tailored to your company:',
    'getstarted.cta': 'Get started now',

    // PROJECTS SECTION
    'projects.badge': 'Our Projects',
    'projects.title': '🎯 Every project is a system running in production',
    'projects.description': 'From sports clubs to IoT livestock traceability: our own products and custom software for companies in Argentina and the region.',
    'projects.visitSite': 'Visit site →',
    'projects.ownProduct': 'AiLosofy Product',
    'projects.client': 'Client',
    'projects.ctaQuestion': 'Want to transform your business with AI?',
    'projects.ctaButton': "Let's talk about your project",

    // PROJECTS — BookerClub
    'projects.booker.subtitle': 'Comprehensive Sports Club Management',
    'projects.booker.desc': 'Multi-tenant SaaS for full club digitalization: classes, schools, tournaments, bar, statistics, and mobile app. Reservation management, payments, and push notifications for padel, tennis, and more.',

    // PROJECTS — ShiftMaster
    'projects.shiftmaster.subtitle': 'Intelligent Shift & Staff Control',
    'projects.shiftmaster.desc': 'HR platform for multi-branch chains: shift control, GPS anti-spoofing attendance, automatic absence detection, and guard coverage system via direct communication.',

    // PROJECTS — Simplificando
    'projects.simplificando.subtitle': 'Domestic Employee Management',
    'projects.simplificando.desc': 'PWA for Argentine self-employed workers that simplifies registration and management of domestic employees. MercadoPago integration, subscriptions, payroll, and automated legal compliance.',

    // PROJECTS — Santa Tabla
    'projects.santatabla.subtitle': 'Smart E-commerce + Automation',
    'projects.santatabla.desc': 'AI-powered platform to optimize sales and shopping experience. Technical shop specializing in boards and water sports equipment since 2013, enhanced with full automation.',

    // PROJECTS — Dato que Dato
    'projects.datoquedato.subtitle': 'Services Marketplace + Geolocation',
    'projects.datoquedato.desc': 'We connect users with trusted urban service professionals. AI prioritizes the highest-rated professionals near the user by trade, making it easy to find the best recommendation for each need.',

    // PROJECTS — CasaBlanca
    'projects.casablanca.subtitle': 'Mallet Configurator + E-commerce',
    'projects.casablanca.desc': 'Order PWA for high-performance carbon fiber polo equipment. 5-step customization flow with real-time SVG mallet render, integrated with repair tracking system.',

    'projects.weatherspot.subtitle': 'Wind & weather for water sports',
    'projects.weatherspot.desc': 'White-label wind forecast PWA for kite, windsurf, and sailing. Integration with 11 Windguru stations via Cloudflare Worker proxy. Real-time data on wind, waves, and weather conditions.',

        // PROJECTS — Ganaval
    'projects.ganaval.subtitle': 'Livestock Traceability with IoT and LoRaWAN',
    'projects.ganaval.desc': 'Bovine livestock tracking and scoring platform with IoT ear tags and LoRaWAN antennas. Allows banks to verify cattle as real-time credit collateral. Pilot in General Pico and Trenque Lauquen.',

        // PROJECTS — SecureTrack Pro
    'projects.securetrack.subtitle': 'Biometric Attendance for Security Cooperatives',
    'projects.securetrack.desc': 'Attendance control platform with a biometric clock-in kiosk and geolocation. Multi-cooperative, with role-based panels and receipts compliant with Art. 42 of Law 20.337. Live in production with Sinergia (~500 members).',

    // PROJECTS — GRIM
    'projects.grim.subtitle': 'Productivity PWA for The GRIM Circle',
    'projects.grim.desc': 'Daily execution system for GRIM Circle members: Deep Work with drag & drop, habit tracking, discipline check-in, GRIM notifications, and weekly goal tracking.',

    // PROJECTS — MJF
    'projects.mjf.subtitle': "Argentina's Land. Your Legacy.",
    'projects.mjf.desc': 'Website for MJ Furtado Advisors, specialist in agricultural land and investments in Argentina. Premium positioning for international buyers seeking high-value rural assets.',
  },

  pt: {

    // NAV — new keys
    'nav.howwework': 'Como trabalhamos',
    'nav.founder': 'Sobre nós',
    'nav.service.whatsapp': 'Automatizar WhatsApp com IA',
    'nav.service.business': 'Automação empresarial',
    'nav.service.data': 'Análise de Dados e Big Data',
    'nav.service.chatbots': 'Chatbots e Assistentes Virtuais',
    'nav.service.logistics': 'Otimização de Processos e Logística',
    'nav.service.marketing': 'Otimização de Marketing Digital',

    // FOOTER
    'footer.tagline': 'Transformamos processos em sistemas inteligentes. IA aplicada a negócios reais.',
    'footer.col.company': 'Empresa',
    'footer.col.services': 'Serviços',
    'footer.col.products': 'Produtos',
    'footer.rights': 'Todos os direitos reservados.',
    'footer.made': 'Feito com IA + engenharia naval',

    // TESTIMONIALS
    'testimonials.badge': 'O que nossos clientes dizem',
    'testimonials.title': 'Resultados reais, empresas reais',
    'testimonials.subtitle': 'Não trabalhamos com promessas. Trabalhamos com entregáveis.',
    'testimonials.t1.name': 'Pamela Torales',
    'testimonials.t1.role': 'BM Paddle',
    'testimonials.t1.quote': 'O BookerClub transformou completamente a gestão do nosso clube. O que antes levava horas de planilhas agora gerenciamos em minutos. O sistema de reservas e notificações mudou a experiência dos nossos sócios.',
    'testimonials.t2.name': 'Marcelo Furtado',
    'testimonials.t2.role': 'MJF Furtado Advisors',
    'testimonials.t2.quote': 'O site funciona perfeitamente. Eu mesmo cadastro e atualizo os imóveis em minutos, sem depender de ninguém, e as descrições em espanhol e inglês funcionam bem para os compradores do exterior. Ficou exatamente como eu precisava.',
    'testimonials.t3.name': 'Leo Risolini',
    'testimonials.t3.role': 'Palo Alto Polo Club',
    'testimonials.t3.quote': 'O Simplificando me poupou horas de burocracia com minha empregada doméstica. Tudo claro, tudo legal, com MercadoPago integrado. Exatamente o que eu precisava sem complicações.',

    // NAV
    'nav.services': 'Serviços',
    'nav.contact': 'Contato',
    'nav.projects': 'Projetos',


    // HERO — new
    'hero.tag': 'Agência de IA · Buenos Aires · LATAM',
    'hero.title1': 'Transformamos seus processos',
    'hero.title2': 'em sistemas inteligentes',
    'hero.subtitle': 'Automação com IA, SaaS sob medida e soluções digitais que geram resultados reais — não promessas genéricas.',
    'hero.cta.primary': 'Vamos falar sobre seu projeto',
    'hero.cta.secondary': 'Ver projetos',
    'hero.stat1.number': '10',
    'hero.stat1.label': 'Projetos em produção',
    'hero.stat2.number': '30+',
    'hero.stat2.label': 'Anos em engenharia de sistemas',
    'hero.stat3.number': '6',
    'hero.stat3.label': 'Setores atendidos',
    'hero.industries': 'Setores: Segurança · Clubes esportivos · Náutica · Agro · Jurídico · Polo',
    // HERO (legacy)
    'hero.description': 'Desenvolvemos soluções personalizadas de IA que aumentam a eficiência e o crescimento do seu negócio. Descubra o poder da automação inteligente com AiLosofy.',

    // SERVICES SECTION
    'services.mainTitle': '💡 Potencialize sua Empresa com IA',
    'services.discover': 'Descubra o poder da Inteligência Artificial para otimizar processos, melhorar a experiência do cliente e levar sua empresa ao próximo nível.',
    'services.whatWeCanDo': '📈 O que podemos fazer por você?',
    'services.automation.title': 'Automação Inteligente',
    'services.automation.description': 'Simplifique tarefas repetitivas e libere tempo para o que realmente importa.',
    'services.predictive.title': 'Análise Preditiva',
    'services.predictive.description': 'Tome decisões baseadas em dados com precisão e rapidez.',
    'services.chatbots.title': 'Assistentes Virtuais Personalizados',
    'services.chatbots.description': 'Melhore o atendimento ao cliente com chatbots inteligentes que entendem e respondem aos seus usuários em tempo real.',
    'services.future.title': '🌐 Experimente o Futuro Hoje',
    'services.future.description': 'Dê o passo em direção à transformação digital com tecnologia de ponta.',

    // WHATSAPP
    'whatsapp.title': 'WhatsApp com Inteligência Artificial',
    'whatsapp.subtitle': 'Transforme o Atendimento ao Cliente com WhatsApp Automatizado e IA',
    'whatsapp.quickResponses': 'Respostas Rápidas e Eficientes',
    'whatsapp.quickResponsesDesc': 'Respostas instantâneas, mesmo fora do horário comercial',
    'whatsapp.availability': 'Disponibilidade 24/7',
    'whatsapp.availabilityDesc': 'Seu negócio sempre disponível para seus clientes',
    'whatsapp.costs': 'Redução de Custos Operacionais',
    'whatsapp.costsDesc': 'Otimize recursos e melhore a eficiência',

    // BUSINESS
    'business.title': 'Automação de Processos Empresariais com IA',
    'business.subtitle': 'Impulsione a Eficiência do Seu Negócio com Inteligência Artificial',
    'business.description': 'Em um ambiente empresarial cada vez mais competitivo, otimizar processos internos é fundamental para melhorar a eficiência e reduzir custos. Aproveitamos o poder da Inteligência Artificial para transformar a maneira como você opera.',

    // DATA
    'data.title': 'Análise de Dados e Big Data',
    'data.subtitle': 'Transformamos dados em decisões estratégicas para impulsionar o crescimento do seu negócio',
    'data.description': 'Utilizamos tecnologias avançadas de análise de dados e Big Data para descobrir padrões, tendências e oportunidades que impulsionam a inovação e o crescimento empresarial.',

    // CHATBOTS
    'chatbots.title': 'Chatbots e Assistentes Virtuais Inteligentes',
    'chatbots.subtitle': 'Transformando o Atendimento ao Cliente com Inteligência Artificial',
    'chatbots.description': 'Na era digital, velocidade e personalização no atendimento ao cliente são essenciais. Oferecemos soluções avançadas projetadas para melhorar a interação com os usuários e otimizar o serviço ao cliente de maneira eficiente.',

    // LOGISTICS
    'logistics.title': 'Otimização de Processos e Logística',
    'logistics.subtitle': 'Transforme sua cadeia de suprimentos com inteligência artificial',
    'logistics.description': 'Em um mundo empresarial cada vez mais exigente, a eficiência em processos e logística é crucial para manter a competitividade. Usamos IA para transformar a forma como você gerencia suas operações.',

    // MARKETING
    'marketing.title': 'Otimização de Marketing Digital com Inteligência Artificial',
    'marketing.subtitle': 'Em um mundo digital em constante evolução, as empresas enfrentam o desafio de se destacar em um mar de concorrentes.',
    'marketing.description': 'A Otimização de Marketing Digital através da Inteligência Artificial se apresenta como uma solução integral para maximizar o impacto de suas campanhas e melhorar a experiência do cliente.',




    // SERVICES DETAIL SECTION
    'svc.badge': 'Nossos Serviços',
    'svc.title': '💡 Soluções de IA para cada necessidade',
    'svc.subtitle': 'Serviços projetados para empresas que querem resultados reais, não projetos piloto eternos.',
    'svc.benefitsTitle': 'Benefícios concretos',
    'svc.cta': 'Quero este serviço',
    // WhatsApp
    'svc.whatsapp.title': 'WhatsApp com Inteligência Artificial',
    'svc.whatsapp.subtitle': 'Automatize seu canal do WhatsApp e atenda 24/7 sem contratar mais pessoal',
    'svc.whatsapp.desc': 'Transformamos seu WhatsApp em um agente de vendas e atendimento ao cliente que nunca dorme. Captura leads, processa pedidos, responde consultas e escala sem limites — tudo integrado aos seus sistemas.',
    'svc.whatsapp.b1': '⚡ Respostas instantâneas 24/7, mesmo fora do horário comercial',
    'svc.whatsapp.b2': '📈 Mais leads capturados sem aumentar a equipe de vendas',
    'svc.whatsapp.b3': '💰 Redução de custos operacionais de atendimento ao cliente',
    'svc.whatsapp.b4': '🔗 Integração com seus sistemas CRM, e-commerce e logística',
    'svc.whatsapp.types': 'Tipos de IA para WhatsApp',
    'svc.whatsapp.t1.label': 'IA para Geração de Leads',
    'svc.whatsapp.t1.desc': 'Captura dados de potenciais clientes em conversas automatizadas e integra ao seu CRM.',
    'svc.whatsapp.t2.label': 'IA de Processamento de Pedidos',
    'svc.whatsapp.t2.desc': 'Permite fazer pedidos, escolher produtos, pagar e receber confirmações sem intervenção humana.',
    'svc.whatsapp.t3.label': 'IA para Suporte Técnico',
    'svc.whatsapp.t3.desc': 'Resolve problemas técnicos desde configurações básicas até incidentes complexos.',
    'svc.whatsapp.t4.label': 'IA de Atendimento ao Cliente',
    'svc.whatsapp.t4.desc': 'Gerencia perguntas frequentes e encaminha casos complexos para um agente humano.',
    // Business Automation
    'svc.business.title': 'Automação de Processos Empresariais',
    'svc.business.subtitle': 'Elimine o trabalho manual e libere sua equipe para o que importa',
    'svc.business.desc': 'Identificamos os processos repetitivos que consomem tempo e os automatizamos com IA. De aprovações de documentos a relatórios automáticos — sua equipe foca em decisões estratégicas.',
    'svc.business.b1': '⏱️ Redução drástica do tempo em tarefas manuais e repetitivas',
    'svc.business.b2': '✅ Zero erros humanos em processos críticos',
    'svc.business.b3': '💸 Menor custo operacional por processo automatizado',
    'svc.business.b4': '📐 Escalável: o sistema cresce com sua empresa sem atrito',
    // Data Analysis
    'svc.data.title': 'Análise de Dados e Big Data',
    'svc.data.subtitle': 'Transforme seus dados em vantagem competitiva',
    'svc.data.desc': 'Você tem dados mas não sabe o que eles estão dizendo. Nós os transformamos em insights acionáveis: quais clientes vão comprar, quais processos estão falhando, onde está a próxima oportunidade.',
    'svc.data.b1': '📊 Decisões baseadas em dados, não em intuição',
    'svc.data.b2': '🔍 Padrões ocultos que sua concorrência não vê',
    'svc.data.b3': '⚙️ Otimização de processos com evidências reais',
    'svc.data.b4': '🏆 Vantagem competitiva sustentável ao longo do tempo',
    // Chatbots
    'svc.chatbots.title': 'Chatbots e Assistentes Virtuais',
    'svc.chatbots.subtitle': 'Atendimento personalizado em escala, sem escalar a equipe',
    'svc.chatbots.desc': 'Construímos assistentes virtuais que entendem o contexto, lembram conversas anteriores e resolvem 80% das consultas sem intervenção humana. Disponíveis no seu site, app ou redes sociais.',
    'svc.chatbots.b1': '🕐 Disponibilidade 24/7 sem interrupções ou folgas',
    'svc.chatbots.b2': '💬 Atendimento personalizado baseado no histórico do usuário',
    'svc.chatbots.b3': '⚡ Múltiplas conversas simultâneas sem degradar a qualidade',
    'svc.chatbots.b4': '🎯 Experiência consistente em todos os canais',
    // Logistics
    'svc.logistics.title': 'Otimização de Processos e Logística',
    'svc.logistics.subtitle': 'Menos custos, mais velocidade, melhor serviço',
    'svc.logistics.desc': 'Aplicamos IA à sua cadeia de suprimentos e operações logísticas. Prevemos demanda, otimizamos rotas, reduzimos estoque desnecessário e melhoramos os prazos de entrega.',
    'svc.logistics.b1': '💰 Redução de gastos operacionais identificando ineficiências',
    'svc.logistics.b2': '📡 Visibilidade em tempo real de produtos e processos',
    'svc.logistics.b3': '🚀 Entregas mais rápidas e menor taxa de erro',
    'svc.logistics.b4': '🔄 Adaptação automática às mudanças de demanda do mercado',
    // Marketing
    'svc.marketing.title': 'Otimização de Marketing Digital',
    'svc.marketing.subtitle': 'Mais impacto com o mesmo orçamento',
    'svc.marketing.desc': 'Usamos IA para segmentar melhor, personalizar conteúdo e otimizar suas campanhas em tempo real. Mais conversões, menor custo de aquisição, melhores clientes.',
    'svc.marketing.b1': '🎯 Segmentação precisa por comportamento e interesses reais',
    'svc.marketing.b2': '👤 Conteúdo personalizado para cada segmento de usuário',
    'svc.marketing.b3': '📈 Monitoramento e otimização de campanhas em tempo real',
    'svc.marketing.b4': '📐 Sistema escalável que melhora a cada campanha',

    // HOW WE WORK
    'howwework.badge': 'Nosso processo',
    'howwework.title': 'Como trabalhamos',
    'howwework.subtitle': 'Um processo claro e comprovado. Sem surpresas, sem promessas vazias — só execução.',
    'howwework.step1.title': 'Discovery',
    'howwework.step1.desc': 'Entendemos seu negócio, seus processos atuais e onde a IA pode gerar o maior impacto.',
    'howwework.step2.title': 'Proposta',
    'howwework.step2.desc': 'Desenhamos a solução técnica e o plano de trabalho com prazos, entregáveis e custos claros.',
    'howwework.step3.title': 'Build',
    'howwework.step3.desc': 'Construímos com metodologia ágil. Iterações rápidas, feedback constante, código limpo.',
    'howwework.step4.title': 'Deploy',
    'howwework.step4.desc': 'Lançamos em produção com testes rigorosos. Sua equipe fica capacitada para operar.',
    'howwework.step5.title': 'Evolução',
    'howwework.step5.desc': 'Monitoramos, melhoramos e escalamos. A solução cresce com seu negócio.',
    'howwework.guaranteesTitle': 'O que garantimos em cada projeto',
    'howwework.g1': '⚡ Primeiros resultados em 30 dias — não esperamos meses para mostrar valor.',
    'howwework.g2': '🔒 IP 100% seu — todo o código e dados pertencem à sua empresa.',
    'howwework.g3': '📦 Entregáveis concretos — documentação, código-fonte e treinamento incluídos.',
    'howwework.g4': '🤝 Comunicação direta — você trabalha com o founder, não com uma cadeia de intermediários.',
    'howwework.cta': 'Inicie seu projeto',

    // FOUNDER SECTION
    'founder.badge': 'A equipe por trás da AiLosofy',
    'founder.title': 'Engenharia de alto desempenho aplicada aos negócios',
    'founder.subtitle': 'Não somos uma agência genérica de IA. Viemos de construir sistemas que não podem falhar — no oceano, em regatas, na indústria.',
    'founder.timelineTitle': 'Trajetória',
    'founder.milestone1': '🎓 Engenheiro Naval com mais de 30 anos em engenharia de sistemas complexos — projetando soluções onde a margem de erro é zero.',
    'founder.milestone2': '🏆 America\'s Cup e Volvo Ocean Race — construção de embarcações e project management em competições de vela de elite, onde prazos, precisão e desempenho sob pressão são inegociáveis.',
    'founder.milestone3': '🚢 Co-fundador da BoatShare, primeira plataforma de compartilhamento de barcos da Argentina — da ideia ao exit.',
    'founder.milestone4': '🤖 Fundador da AiLosofy: agência de IA e estúdio de SaaS com 8+ produtos lançados em segurança, clubes esportivos, náutica, agro, jurídico e polo.',
    'founder.pillarsTitle': 'O que nos torna diferentes',
    'founder.pillar1': '🧠 Pensamento sistêmico aplicado — cada solução de IA é projetada como um sistema, não como um remendo.',
    'founder.pillar2': '⚙️ Builder, não apenas consultor — construímos os produtos que vendemos e os usamos nós mesmos.',
    'founder.pillar3': '🌊 Cultura de alto desempenho — viemos de ambientes onde a mediocridade não é uma opção.',
    'founder.pillar4': '🌎 LATAM-first com visão global — profundo conhecimento do mercado local com capacidade de escalar internacionalmente.',
    'founder.cta': 'Vamos trabalhar juntos',

    // CONTACT
    'contact.title': 'Leve sua empresa ao Próximo Nível',
    'contact.description': 'Na AiLosofy, desenvolvemos soluções de automação personalizadas para cada empresa, garantindo que seu negócio melhore em eficiência, agilidade e adaptação.',
    'contact.faq': 'Perguntas Frequentes',
    'contact.contactUs': 'Entre em Contato',
    'contact.name': 'Nome completo',
    'contact.email': 'E-mail',
    'contact.phone': 'Telefone',
    'contact.message': 'Mensagem',
    'contact.send': 'Enviar Mensagem',
    'contact.heading': 'Contato',
    'contact.subheading': 'Comece a automatizar sua empresa com AiLosofy e nossos serviços de Inteligência Artificial para melhorar a produtividade.',
    'contact.chatbot': 'Você também pode usar nosso chatbot para nos contatar 24/7',
    'contact.founderBook': 'Livro do fundador',
    'contact.bookTitle': 'Quando Não Fazer Nada',
    'contact.bookAvailable': 'Disponível na Amazon',

    // GET STARTED
    'getstarted.title': 'Leve sua empresa ao Próximo Nível',
    'getstarted.description': 'Na AiLosofy, desenvolvemos soluções de automação personalizadas para cada empresa, garantindo que seu negócio melhore em eficiência, agilidade e adaptação.',
    'getstarted.faq': 'Perguntas Frequentes',
    'getstarted.optimize': 'Otimize seu negócio com Inteligência Artificial',
    'getstarted.question': 'Quer melhorar a eficiência da sua empresa e aumentar seus resultados com Inteligência Artificial? 🚀',
    'getstarted.body1': 'Na AiLosofy, desenvolvemos soluções de IA personalizadas para otimizar processos, automatizar tarefas e potencializar seu negócio.',
    'getstarted.body2': 'Conte-nos o que você precisa e descubra como podemos ajudar. Preencha o formulário e entraremos em contato com uma proposta adaptada à sua empresa:',
    'getstarted.cta': 'Começar agora',

    // PROJECTS SECTION
    'projects.badge': 'Nossos Projetos',
    'projects.title': '🎯 Cada projeto é um sistema rodando em produção',
    'projects.description': 'De clubes esportivos à rastreabilidade pecuária com IoT: produtos próprios e software sob medida para empresas da Argentina e da região.',
    'projects.visitSite': 'Visitar site →',
    'projects.ownProduct': 'Produto AiLosofy',
    'projects.client': 'Cliente',
    'projects.ctaQuestion': 'Quer transformar seu negócio com IA?',
    'projects.ctaButton': 'Vamos falar sobre seu projeto',

    // PROJECTS — BookerClub
    'projects.booker.subtitle': 'Gestão Integral de Clubes Esportivos',
    'projects.booker.desc': 'SaaS multi-tenant para digitalização total de clubes: aulas, escolinhas, torneios, bar, estatísticas e app móvel. Gestão de reservas, pagamentos e notificações push para padel, tênis e mais.',

    // PROJECTS — ShiftMaster
    'projects.shiftmaster.subtitle': 'Controle Inteligente de Turnos e Pessoal',
    'projects.shiftmaster.desc': 'Plataforma de RH para redes multi-filial: controle de turnos, presença com GPS anti-spoofing, detecção automática de ausências e sistema de cobertura de guardas via comunicação direta.',

    // PROJECTS — Simplificando
    'projects.simplificando.subtitle': 'Gestão de Empregados Domésticos',
    'projects.simplificando.desc': 'PWA para autônomos argentinos que simplifica o registro e gestão de empregados domésticos. Integração com MercadoPago, assinaturas, folha de pagamento e conformidade legal automatizada.',

    // PROJECTS — Santa Tabla
    'projects.santatabla.subtitle': 'E-commerce Inteligente + Automação',
    'projects.santatabla.desc': 'Plataforma com IA para otimizar vendas e experiência de compra. Loja técnica especializada em pranchas e equipamentos para esportes aquáticos desde 2013, potencializada com automação total.',

    // PROJECTS — Dato que Dato
    'projects.datoquedato.subtitle': 'Marketplace de Serviços + Geolocalização',
    'projects.datoquedato.desc': 'Conectamos usuários com profissionais de serviços urbanos confiáveis. A IA prioriza os mais bem avaliados perto do usuário por ofício, facilitando encontrar o profissional mais recomendado para cada necessidade.',

    // PROJECTS — CasaBlanca
    'projects.casablanca.subtitle': 'Configurador de Mallets + E-commerce',
    'projects.casablanca.desc': 'PWA de pedidos para equipamentos de polo de alta performance em fibra de carbono. Fluxo de personalização em 5 etapas com render SVG de mallets em tempo real, integrado com sistema de reparo.',

    'projects.weatherspot.subtitle': 'Vento e clima para esportes aquáticos',
    'projects.weatherspot.desc': 'PWA white-label de previsão de vento para kite, windsurf e vela. Integração com 11 estações Windguru via Cloudflare Worker proxy. Dados em tempo real de vento, ondas e condições meteorológicas.',

        // PROJECTS — Ganaval
    'projects.ganaval.subtitle': 'Rastreabilidade Pecuária com IoT e LoRaWAN',
    'projects.ganaval.desc': 'Plataforma de rastreamento e pontuação de bovinos com brincos IoT e antenas LoRaWAN. Permite que bancos verifiquem o gado como garantia de crédito em tempo real. Piloto em General Pico e Trenque Lauquen.',

        // PROJECTS — SecureTrack Pro
    'projects.securetrack.subtitle': 'Ponto Biométrico para Cooperativas de Segurança',
    'projects.securetrack.desc': 'Plataforma de controle de presença com quiosque de ponto biométrico e geolocalização. Multi-cooperativa, com painéis por perfil e comprovantes conforme o Art. 42 da Lei 20.337. Em produção com a Sinergia (~500 associados).',

    // PROJECTS — GRIM
    'projects.grim.subtitle': 'PWA de Produtividade para The GRIM Circle',
    'projects.grim.desc': 'Sistema de execução diária para membros do GRIM Circle: Deep Work com drag & drop, acompanhamento de hábitos, check-in de disciplina, notificações GRIM e acompanhamento de metas semanais.',

    // PROJECTS — MJF
    'projects.mjf.subtitle': 'Argentina\'s Land. Your Legacy.',
    'projects.mjf.desc': 'Site para MJ Furtado Advisors, especialista em terras agrícolas e investimentos na Argentina. Posicionamento premium para compradores internacionais que buscam ativos rurais de alto valor.',
  },
};